import { Component, Input } from '@angular/core';
import { CustomerAddress } from '@dato-proxy/entities/customeraddress.entity';
import { State } from '@dato-proxy/entities/state.entity';
import { EnumCustomerAddressTypes } from '@dato-proxy/enums';
import { BaseComponent } from '@m4u-angular/base/component/BaseComponent';
import { ServiceBagService } from '@m4u-angular/base/component/ServiceBag';
import { BaseState } from '@m4u-angular/base/entities/BaseEntities';

@Component({
  selector: 'app-customer-address-list',
  templateUrl: './customer-address-list.component.html',
  styleUrls: ['./customer-address-list.component.scss']
})
export class CustomerAddressListComponent extends BaseComponent<BaseState> {
    @Input() DataSource: CustomerAddress[];
    @Input() IsAllowEdit: boolean;
    @Input() public Type: EnumCustomerAddressTypes;

    constructor(A: ServiceBagService) {
        super(A, "CustomerAddressListComponent", State);
    }

    override IsUseFinishCycleChangeDetection(): boolean { return false; }

    GetMenu(customerAddress: CustomerAddress) {
        if (!this.IsAllowEdit) return [];
        return [{
            text: this.RC('lblEditCustomerAddress'),
            icon: 'mdi mdi-pencil',
            onClick: () => this.OnEditAddress(customerAddress.EntryID, 'edit')
        }];
    }

    OnEditAddress(entryID, mode: 'new' | 'edit') {
        if (!this.IsAllowEdit) return;

        this.Navigate(["/pages/customer-address/", mode === 'new' ? 'new' : entryID], { Type: this.Type });
    }
}
